export default __webpack_public_path__ + "static/media/Landing-Packages-Home.c6790130.svg";